/**
 * Web component: FAQ section (faq-section)
 * -----------------------------------------------------------------------------
 * Section for displaying FAQs.
 *
 */
import './faq-section.scss'

import { vueReady } from '~/core/runners'

/**
 * Create new <faq-section> custom element.
 */
class FaqSection extends HTMLElement {
  static observedAttributes = []

  /**
   * Custom element constructor.
   * - Always call super first in constructor.
   */
  constructor() {
    super()
    this.data = 'example'
  }

  /**
   * Lifecycle hook - component is attached to DOM.
   */
  connectedCallback() {
    const faqs = this.querySelectorAll('[js-faq="group"]')

    faqs.forEach(faq => {
      faq.addEventListener('click', () => {
        const group = faq.querySelector('.faq-section__question-group')
        const answer = faq.querySelector('.faq-section__answer')

        answer.style.height = 'auto'

        const targetHeight = getComputedStyle(answer).height

        answer.style.height = 0

        // eslint-disable-next-line no-unused-expressions
        getComputedStyle(answer).height

        if (group.classList.contains('active')) {
          group.classList.remove('active')
          requestAnimationFrame(() => {
            answer.style.height = answer.animate({
              height: [targetHeight, 0],
            }, {
              duration: 400,
              easing: 'ease-out',
            })
          })

          return
        }

        group.classList.add('active')
        requestAnimationFrame(() => {
          answer.style.height = targetHeight
        })
      })
    })
  }

  /**
   * Observed attribute changed.
   */
  attributeChangedCallback(name, oldValue, newValue) {
    window.console.log(`Attribute ${name} has changed`, oldValue, newValue)
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('faq-section')) {
    return
  }

  customElements.define('faq-section', FaqSection)
})
